export default "__VITE_ASSET__CIk1NmLb__"